import { useEffect } from 'react';
import { useTheme } from './hooks/useTheme';
import Home from './Home';

function App() {
  const { theme } = useTheme();

  useEffect(() => {
    // Дополнительные эффекты при изменении темы
    console.log(`Current theme: ${theme}`);
  }, [theme]);

  return (
    <div className={`min-h-screen bg-white dark:bg-gray-900 transition-colors duration-300`}>
      <Home />
    </div>
  );
}

export default App;